import React from "react";
import { Button, DatePicker, Input, Space } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const ReportToolbar = ({
  filterDate,
  onDateChange,
  searchTerm,
  onSearchChange,
  onSearchKeyDown,
  onSubmitSearch,
  onResetFilters,
  searchInputValue,
  onDownload,
  downloadDisabled,
  showDownload,
}) => {
  return (
    <div className="text-end pb-2 gap-2">
      <Space direction="vertical" size={14} className="w-52"></Space>
      <RangePicker
        onChange={onDateChange}
        value={
          filterDate
            ? [dayjs(filterDate[0]), dayjs(filterDate[1])]
            : [dayjs(), dayjs()]
        }
      />{" "}
      &nbsp;
      <Input
        value={searchInputValue}
        className="w-48 font-poppins ml-1"
        placeholder="Search"
        onChange={onSearchChange}
        onKeyDown={onSearchKeyDown}
        allowClear
      />
      <Button
        type="primary"
        onClick={onSubmitSearch}
        disabled={!searchTerm?.trim()}
        className="rounded-1xbg-indigo-500 text-decoration-none fs-8 hover:scale-105 duration-300 text-white ml-2"
      >
        ok
      </Button>
      <Button onClick={onResetFilters} className="ml-2">
        Reset filter
      </Button>
      {showDownload && (
        <Button
          type="default"
          onClick={onDownload}
          disabled={downloadDisabled}
          className="ml-2"
        >
          Download report
        </Button>
      )}
    </div>
  );
};

export default ReportToolbar;
